import React, { ElementType } from 'react';

import Box, { BoxProps } from '@mui/material/Box';
import Button from '@mui/material/Button';
import { ButtonProps } from '@mui/material/Button';

export interface ClientButtonProps extends ButtonProps {
  text: string;
  boxProps?: BoxProps;
  component?: ElementType;
}

export const BoxedButton: React.FC<ClientButtonProps> = ({ text, boxProps, ...buttonProps }) => {
  const clientBtnProps = { ...buttonProps };
  if (!clientBtnProps.variant) {
    clientBtnProps.variant = 'contained';
  }
  if (!clientBtnProps.color) {
    clientBtnProps.color = 'primary';
  }
  if (boxProps) {
    return (
      <Box {...boxProps}>
        <Button {...clientBtnProps}>{text}</Button>
      </Box>
    );
  }
  return <Button {...clientBtnProps}>{text}</Button>;
};
